export enum ROLE_CODES {
    LOYYAL_ADMIN = 'LOYYAL_ADMIN',
    PERK_POINT_ADMIN = 'PERK_POINT_ADMIN',
    PERK_POINT_PROGRAM = 'PERK_POINT_PROGRAM',
    PROGRAM_ADMIN = 'PROGRAM_ADMIN',
    MERCHANT_ADMIN = 'MERCHANT_ADMIN'
}
